import { AddressState } from 'types'
import { getObject, LocalStorageKeys, setObject } from './storage'

interface UserData {
  email?: string
  dateOfBirth?: string
  state?: AddressState
  firstName?: string
  lastName?: string
  phoneNumber?: string
  sex?: 'Female' | 'Male'
  termsOfUseConsent?: boolean
  dexcomDataShareConsent?: boolean // consent to share Dexcom data, only used on Dexcom flow
  northwesternPhiConsent?: boolean
  clinic?: string
}

export const getUserData = (): UserData | null => getObject<UserData>(LocalStorageKeys.UserData)

export const setUserData = (userData: Partial<UserData>) => {
  const currentUserData = getUserData()

  setObject(LocalStorageKeys.UserData, { ...currentUserData, ...userData })
}
